<template>
  <AppSidebar />
  <div
    class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent"
  >
    <UmwaHeader />
    <div class="body flex-grow-1">
      <router-view />
    </div>
    <AppFooter />
  </div>
</template>
<script>
import AppFooter from '@/components/AppFooter.vue'
import UmwaHeader from '@/components/Umwa/UmwaHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'UmwaLayout',
  components: {
    AppFooter,
    UmwaHeader,
    AppSidebar,
  },
  data() {
    return {
      message: localStorage.getItem('message'),
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    },
  },
}
</script>
